import * as API from '../'
export default {
    checkcode: params => {
        return API.GET('/api/eventdict/checkcode', params)
    },
    getList:params =>{
        return API.GET('/api/eventdict/list',params)
    },
    getAllList:params =>{
        return API.GET('/api/eventdict/allList',params)
    },
    insert:params=>{
        return API.postJsonRequest('/api/eventdict/insert',params)
    },
    update:params=>{
        return API.postJsonRequest('/api/eventdict/update',params)
    },
    remove: id => {
        return API.GET('/api/eventdict/remove/' + id)
    },
    allSupplier:params=>{
        return API.GET('/api/deviceSupplier/allList',params)
    },
    getComboxList: params =>{
        return API.GET('/api/eventdict/combox',params)
    },
    getRuleList:params=>{
        return API.GET('/api/eventdict/getDeviceEventRule',params)
    },
    updateRule:params =>{
        return API.postJsonRequest('/api/eventdict/updateDeviceRule',params)
    },
    insertRule:params =>{
        return API.postJsonRequest('/api/eventdict/insertDeviceRule',params)
    },
    deleteRule:params =>{
        return API.postJsonRequest('/api/eventdict/deleteDeviceRule',params)
    },
    getDictCombox:params =>{
        return API.GET('/api/dict/code',params)
    }
}


// WEBPACK FOOTER //
// ./src/api/device/api_deviceEventDictionary.js